/*
  Newsletter: sendet Anmeldungen direkt an Klaviyos öffentliche Client-API
  (keine App, keine Kosten) und steuert das Popup.

  Die Konto-ID (öffentlicher Schlüssel) und die Listen-ID sind keine Geheimnisse,
  sie stehen auch im Klaviyo-Snippet jeder Seite. Ob eine Bestätigungs-Mail
  (Double-Opt-in) verschickt wird, entscheidet die Liste in Klaviyo.
*/
(() => {
  const FIRMA = 'XixEHk';
  const LISTE = 'SdL3qW';
  const REVISION = '2024-10-15';
  const MERKER = 'bbc-nl-popup';
  const PAUSE_TAGE = 14;
  const VERZOEGERUNG = 25000;

  const lesen = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const schreiben = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* ignorieren */ } };

  async function anmelden(formular) {
    const status = formular.querySelector('[data-nl-status]');
    const mail = formular.elements.email.value.trim();
    const setzen = (text, klasse) => {
      status.textContent = text;
      status.className = `nl__status ${klasse || ''}`;
    };

    if (formular.elements.website.value) return; // Bot
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) {
      setzen('Bitte gib eine gültige E-Mail-Adresse ein.', 'ist-fehler');
      return;
    }
    if (!formular.elements.einwilligung.checked) {
      setzen('Bitte stimme dem Erhalt von E-Mails zu.', 'ist-fehler');
      return;
    }

    const knopf = formular.querySelector('button[type="submit"]');
    knopf.disabled = true;
    setzen('Einen Moment …');

    const profil = { type: 'profile', attributes: { email: mail } };
    if (formular.dataset.warteliste) {
      profil.attributes.properties = { probierpaket_warteliste: true };
    }

    try {
      const antwort = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${FIRMA}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: `Website: ${formular.dataset.quelle}`,
              profile: { data: profil }
            },
            relationships: { list: { data: { type: 'list', id: LISTE } } }
          }
        })
      });
      if (!antwort.ok) throw new Error(String(antwort.status));

      formular.classList.add('ist-fertig');
      setzen('Fast geschafft: Bitte bestätige deine Anmeldung über die E-Mail, die wir dir gerade schicken.', 'ist-erfolg');
      schreiben(MERKER, String(Date.now() + 365 * 864e5)); // angemeldet: Popup bleibt aus
    } catch (e) {
      knopf.disabled = false;
      setzen('Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.', 'ist-fehler');
    }
  }

  document.addEventListener('submit', (ereignis) => {
    const formular = ereignis.target.closest?.('[data-newsletter]');
    if (!formular) return;
    ereignis.preventDefault();
    anmelden(formular);
  });

  /* ---------------------------------------------------------------- *
     Popup
   * ---------------------------------------------------------------- */
  function popup() {
    const dialog = document.querySelector('[data-nl-popup]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (Number(lesen(MERKER)) > Date.now()) return;

    let gezeigt = false;
    const zeigen = () => {
      if (gezeigt) return;
      // Nicht aufpoppen, solange Warenkorb oder ein anderer Dialog offen ist.
      if (document.querySelector('dialog[open]') || document.body.style.overflow === 'hidden') {
        window.setTimeout(zeigen, 5000);
        return;
      }
      gezeigt = true;
      dialog.showModal();
      schreiben(MERKER, String(Date.now() + PAUSE_TAGE * 864e5));
    };

    window.setTimeout(zeigen, VERZOEGERUNG);
    // Desktop: Maus verlässt das Fenster nach oben
    document.addEventListener('mouseout', (e) => {
      if (e.clientY <= 0 && !e.relatedTarget) zeigen();
    });

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-nl-popup-zu]')) dialog.close();
    });
  }

  /* Cross-Sell im Warenkorb: Produkt per Klick hinzufügen; cart-drawer.js lädt den Warenkorb neu. */
  document.addEventListener('click', async (ereignis) => {
    const knopf = ereignis.target.closest('[data-cart-add]');
    if (!knopf || knopf.disabled) return;

    knopf.disabled = true;
    try {
      const antwort = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(knopf.dataset.cartAdd), quantity: 1 })
      });
      if (!antwort.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('bbc:cart:added'));
    } catch (e) {
      knopf.disabled = false;
    }
  });

  popup();
})();